module.exports = __webpack_public_path__ + "static/img/OHSection.7c0947b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/OHSection.gif
// module id = i4vc
// module chunks = 0